import React, { FC, ReactElement, useEffect, useRef, useState } from 'react';
import cns from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAllStyle } from '../../../stores/reducers/sections';
import routes from '../../../config/routes';
import { getContentDataStream, getEventKey, getNavmenuButtonsVisibility, getContentDataAbout, getPrivateEventState } from '../../../stores/reducers/userData';
import { internalizationState, getUniqueWatchKey } from '../../../stores/reducers/sections';
import localeFieldResolver from '../../../helpers/locale-field-finder';
import './LivePage.sass';

export interface Props {
  className?: string;
  bgSettings?: {
    color?: string;
    isDark?: boolean;
  };
  sectionId: string;
}

const LivePage: FC<Props> = ({ className, bgSettings, sectionId }): ReactElement => {
  const history = useHistory();
  const pageAvailable = useSelector(getNavmenuButtonsVisibility)[2];
  const eventKey = useSelector(getEventKey);
  const pageContent = useSelector(getContentDataStream);
  const { backendURL } = useSelector(getContentDataAbout);
  const { activeLangState } = useSelector(internalizationState);
  const uniqueWatchKey = useSelector(getUniqueWatchKey);
  const isPrivateEvent = useSelector(getPrivateEventState);
  const [searchParams, setSearchParams] = useState<string>();
  const location = useLocation();
  const styles = useSelector(getAllStyle);

  if (!pageAvailable) {
    history.push(routes.REGISTER);
  } else {
    window.dispatchEvent((window as any).livePageOpen);
  }

  // const playerBlock = (
  //   <div id="comdi-player" data-comdi-event={eventKey} lang={activeLangState}>
  //     { localizedName('player_ru') }
  //   </div>
  // );
  const playerContainer = useRef(null);

  useEffect(() => {
    if (location.search && !searchParams) {
      setSearchParams(location.search);
    }

    if (playerContainer && playerContainer.current) {
      (playerContainer.current! as HTMLElement).innerHTML = '';
      const el = document.createElement('div');
      el.id = 'comdi-player';
      el.setAttribute('data-comdi-event', uniqueWatchKey || eventKey);
      el.setAttribute('lang', activeLangState);
      if (location.search) {
        location.search.replace(/\?/, '').split('&').forEach((param) => {
          const [key, value] = param.split('=');
          el.setAttribute(`data-${key}`, value);
        });
      }

      (playerContainer.current! as HTMLElement).appendChild(el);
      if (el) {
        (window as any).broadcastLoader.createPlayer(el);
      }
    }
  }, [activeLangState, eventKey, uniqueWatchKey, history, searchParams]);

  useEffect(() => {
    if (searchParams && !location.search) {
      window.location.search = searchParams;
    }

  }, [searchParams])

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);

  const backgroundSettings = () => {
    const defaultSetting = {
      backgroundColor: bgSettings?.color
    };

    if (!pageContent) {
      return defaultSetting;
    }

    const backgroundImage = !isMobile ? pageContent.desktopImage : pageContent.mobileImage;

    return {
      backgroundColor: pageContent.color ? pageContent.color : bgSettings?.color,
      backgroundImage: `url(${backendURL}${backgroundImage})`,
      backgroundPositionX: 'center',
      backgroundPositionY: 'top',
      backgroundOrigin: 'padding-box',
      backgroundAttachment: 'scroll',
      backgroundClip: 'border-box',
      backgroundSize: '100%',
      backgroundRepeat: 'no-repeat',
    };
  };

  return (
    <>
      {
        (isPrivateEvent && !uniqueWatchKey) ? (
          <div className="live-private">
            <h2 className="live-private__title">Данное мероприятие доступно только по уникальной ссылке. <br /> Пожалуйста, перейдите по ссылке из письма.</h2>
          </div>
        ) :
        (
          <section
            className={cns(
              'static-page-section',
              // bgSettings && bgSettings.isDark && 'inner-section--dark-bg',
              className
            )}
            id={sectionId}
            style={{ backgroundColor: 'transparent', position: 'relative' }}>
            <div className="live-background" style={backgroundSettings()} />
            { +styles.playerSettings.playerWidth < 95 &&
              <div style={{ padding: '28px 0' }} />
            }
            <div className="live-player-container">
              <div ref={playerContainer}>
                {/* {playerBlock} */}
              </div>
            </div>
            <div className="container" style={{position: 'relative'}}>
              {
                pageContent && (
                  <div className="container-tags">
                    {Object.keys(pageContent)
                      .filter((key) => key.includes('tag'))
                      .map((key, ind) => (
                        <span key={ind} className="tag bgc-pink">
                          {/* {(pageContent as any)[key]} */}
                          {key.indexOf('_en') < 0 && localeFieldResolver(pageContent, key, activeLangState)}
                        </span>
                      )
                    )}
                  </div>
                )
              }
              {
                (pageContent?.text || pageContent?.text_en) && <p className="static-page-text user-fs-text">{ localeFieldResolver(pageContent, 'text', activeLangState)}</p>
              }
            </div>
          </section>
        )
      }
    </>
  );
};

export default LivePage;
